import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';

import { Grouping } from '@classes/grouping/grouping';
import { Organism } from '@classes/organism/organism';
import { GroupingService } from '@services/grouping.service';
import { OrganismService } from '@services/organism.service';
import { UiService } from '@services/ui.service';
import { UserService } from '@services/user.service';
import { ProviderType } from '@enums/provider-type.enum';

@Component({
    selector: 'app-group-edit',
    templateUrl: './group-edit.component.html',
    styleUrls: ['./group-edit.component.scss']
})
export class GroupEditComponent implements OnInit, OnDestroy {
    @Input() group: Grouping;

    private loadingSub: Subscription;
    private selectGroupSub: Subscription;
    private userParamSub: Subscription;

    availableOrganisms: Organism[];
    selectedOrganisms: Organism[] = [];

    compareGroupForm: FormGroup;

    minSelected = 3;
    isLoading: boolean;

    constructor(
        private compareSrv: GroupingService,
        private organismSrv: OrganismService,
        private userSrv: UserService,
        private uiSrv: UiService,
        private fb: FormBuilder
    ) { }

    ngOnInit() {
        this.initSubscriptions();
    }

    onValidate(): void {
        this.group.text.shortLabel = this.compareGroupForm.value.name;
        this.group.text.fullLabel = this.compareGroupForm.value.name;
        this.group.isPublic = this.compareGroupForm.value.isPublic;
        this.group.organisms = [ ...this.selectedOrganisms ];

        this.isLoading = true;

        if(this.group.code != null) {
            this.compareSrv.put(this.group).subscribe(() => this.isLoading = false);
        } else {
            this.compareSrv.post(this.group).subscribe(() => this.isLoading = false);
        }
    }

    onCancel(): void {
        this.compareSrv.selectedGroupChanged.next(null);
    }

    private initSubscriptions(): void {
        this.isLoading = true;

        this.organismSrv.getList({fromOrigin: true, isTest: false, withUserOrigin: true})
        .subscribe(organismsFromSrv => {
            this.availableOrganisms = organismsFromSrv;
            this.isLoading = false;
            this.initForm();
        });

        this.selectGroupSub = this.compareSrv.selectedGroupChanged
        .subscribe(selectedGroup => {
            this.group = selectedGroup;
            if(this.availableOrganisms) {
                this.initForm();
            }
        });

        // TODO: Improve this shit
        this.userParamSub = this.userSrv.userParametersSubject
        .subscribe(() => {
            if(this.userSrv.providerTypeMatches(ProviderType.bbc)) {
                this.minSelected = 1;
            }
        });

        this.loadingSub = this.uiSrv.loadingStateChanged
        .subscribe(loadingState => {
            this.isLoading = loadingState;
        });
    }

    private initForm(): void {
        let name = "";
        let isPublic = false;

        this.selectedOrganisms = [];

        if(this.group) {
            name = this.group.text.shortLabel;
            isPublic = this.group.isPublic;
            this.selectedOrganisms = this.group.organisms || [];
        }

        this.compareGroupForm = this.fb.group({
            name : [name, [Validators.required, Validators.maxLength(25)]],
            isPublic: [isPublic]
        });
    }

    ngOnDestroy(): void {
        if(this.loadingSub) {
            this.loadingSub.unsubscribe();
        }

        if(this.selectGroupSub) {
            this.selectGroupSub.unsubscribe();
        }

        if(this.userParamSub) {
            this.userParamSub.unsubscribe();
        }
    }
}
